import { InlineMap } from '../aoraki/maps-react/src/components'
import useInlineMap, { LOCATION_FIELD_DEFAULT } from '../../hooks/use-inline-map'
import { defaultIcon } from '../../services/generic-search'
import { getBaseLayers } from '../../config/map'

export type LocationMapViewType = {
  labelId: string
  value: string
}
export interface LocationMapViewProps {
  projectionType: LocationMapViewType
  easting: LocationMapViewType
  northing: LocationMapViewType
  isLoading?: boolean
  isMapHidden?: boolean
}

export default function LocationMapView({
  projectionType,
  easting,
  northing,
  isMapHidden = false,
}: LocationMapViewProps) {
  const { startPosition } = useInlineMap({
    xCoordinate: easting.value,
    yCoordinate: northing.value,
    projectionType: projectionType.value,
  })
  return (
    <>
      {!isMapHidden && (
        <InlineMap
          isEditable={false}
          position={startPosition}
          markerIcon={defaultIcon}
          getBaseLayers={getBaseLayers}
          zoom={startPosition ? LOCATION_FIELD_DEFAULT.LOCATION_SET : LOCATION_FIELD_DEFAULT.NO_LOCATION}
          isMarkerDraggable={false}
        />
      )}
    </>
  )
}
